<div mat-dialog-draggable-title> <!-- cdkDrag cdkDragRootElement=".cdk-overlay-pane"-->
	<a class="float-right btnClose" (click)="cerrarPopup()"><i class="fal fa-times" style="cursor: pointer;"></i></a>
	<a class="float-right btnClose" (click)="maximizarPopup()"><i class="fal fa-window-maximize"></i></a>
	<a class="float-right btnClose" (click)="minimizarPopup()"><i class="fal fa-window-minimize"></i></a>
	<div class="matTitulo">
		<i class="fas fa-engine-warning" id="ico"></i>
		<h1 style="display:inline-block;">Alertado</h1>
	</div>
	<mat-divider></mat-divider>
</div>
<div class="mt-2" style="margin: 0 auto;">
	<mat-card>
		<div class="row">
			<div class="col-md-6">
				<div class="mt-3">
					<h1>{{vehiculosData.nombreCliente}}</h1>
				</div>
				<div class="row">
					<div class="col-md-6">
						<span>A quien corresponda</span>
					</div>
					<div class="col-md-6">
						<span class="negrita">{{fecha}}</span>
					</div>
					<div class="col-md-12">
						<span>Presente,</span>
					</div>
					<div class="col-md-12">
						<span>
							{{mensaje}}
						</span>
					</div>
					<div class="col-md-12 mt-3">
						<span class="negrita">Datos del Vehículo</span>
					</div>
					<div class="col-md-12">
						<div class="row">
							<div class="col-md-4">
								<span>Vehículo:</span>
							</div>
							<div class="col-md-4">
								{{vehiculosData.marca}}
							</div>
							<div class="col-md-4">
								{{vehiculosData.modelo}}
							</div>
						</div>
						<div class="row">
							<div class="col-md-4">
								<span>Económico:</span>
							</div>
							<div class="col-md-4">
								<span>{{vehiculosData.economico}}</span>
							</div>
						</div>
						<div class="row">
							<div class="col-md-4">
								<span>Placas:</span>
							</div>
							<div class="col-md-4">
								<span>{{vehiculosData.placas}}</span>
							</div>
						</div>
						<div class="row">
							<div class="col-md-4">
								<span>Fecha y hora:</span>
							</div>
							<div class="col-md-4">
								<span>{{vehiculosData.fechaHora}}</span>
							</div>
						</div>
						<dx-validation-group #targetGroup>
							<div class="row">
								<div class="col-md-4">
									<span>Lugar:</span>
								</div>
								<div class="col-md-8 mt-3">
									<dx-text-area [height]="60" [maxLength]="maxLength" [(value)]="lugar">
										<dx-validator>
											<dxi-validation-rule message="Campo requerido" type="required">
											</dxi-validation-rule>
										</dx-validator>
									</dx-text-area>
								</div>
							</div>
							<div class="row mt-3">
								<div class="col-md-4">
									<span>Situación:</span>
								</div>
								<div class="col-md-8">
									<dx-text-area [height]="60" [maxLength]="maxLength" [(value)]="situacion">
										<dx-validator>
											<dxi-validation-rule message="Campo requerido" type="required">
											</dxi-validation-rule>
										</dx-validator>
									</dx-text-area>
								</div>
							</div>
							<div class="row mt-3">
								<div class="col-md-4">
									<span>Contacto:</span>
								</div>
								<div class="col-md-8">
									<dx-text-box [(value)]="contacto">
										<dx-validator>
											<dxi-validation-rule message="Campo requerido" type="required">
											</dxi-validation-rule>
										</dx-validator>
									</dx-text-box>
								</div>
							</div>
							<div class="row mt-3">
								<div class="col-md-4">
									<span>Inicio de llamada:</span>
								</div>
								<div class="col-md-8">
									<dx-date-box [(value)]="inicioLlamada" type="time">
										<dx-validator>
											<dxi-validation-rule message="Campo requerido" type="required">
											</dxi-validation-rule>
										</dx-validator>
									</dx-date-box>
								</div>
							</div>
							<div class="row mt-3">
								<div class="col-md-4">
									<span>Fin de llamada:</span>
								</div>
								<div class="col-md-8">
									<dx-date-box [(value)]="finLlamada" type="time">
										<dx-validator>
											<dxi-validation-rule message="Campo requerido" type="required">
											</dxi-validation-rule>
										</dx-validator>
									</dx-date-box>
								</div>
							</div>
						</dx-validation-group>
						<div class="row mt-3">
							<div class="col-md-12">
								<span>Sin más por el momento, estoy a sus órdenes</span>
							</div>
						</div>
						<div class="row mt-3">
							<div class="col-md-6">
								<span>A T E N T A M E N T E</span><br>
								<span>{{usuario}}</span><br>
								<span>GTM Tecnología S.A. de C.V.</span>
							</div>
							<div class="col-md-6" style="text-align: right;">
								<button id="boton-sion" mat-raised-button class="btn btn-success" (click)="imprimirPdf()"
									style="margin-right: 15px;"><i class="fas fa-file-pdf"></i>&nbsp;Generar
									PDF</button>&nbsp;
							</div>
						</div>
					</div>
				</div>
			</div>
			<div class="col-sm-6 col-md-6 col-lg-6">
				<div class="map-content" id="map-content">
					<div class="content-botones" style="display: none;" id="botonesRecorrido">
						<button (click)="roadmap();" class="btn btn-primary">
							Mapa</button>
						<button (click)="hybrid();" class="btn btn-primary">
							Satélite</button>
					</div>
					<div id="map-marker" class="map-marker">
					</div>
				</div>
			</div>
			<div class="col-md-12 mt-3" style="text-align: center;">
				<span>GTM Tecnología S.A. de C.V.</span>
			</div>
			<div class="col-md-12" style="text-align: center;">
				<span>Carr. Temixco - Emiliano Zapata # ext. 17 # int. 3B Col.  Palo Escrito, Emiliano Zapata, Morelos, Mex. C.P. 62760</span>
			</div>
			<div class="col-md-12" style="text-align: center;">
				<span>Tel. +52 7773200301, Whatsapp: +52 7771351886, monitoreo@gtmtec.mx</span>
			</div>
		</div>
	</mat-card>
</div>
<dx-load-panel
    #loadPanel
    shadingColor="rgba(0,0,0,0.4)"
    [(visible)]="loadingVisible"
    [showIndicator]="true"
    [showPane]="true"
    [shading]="true"
    [closeOnOutsideClick]="false">
</dx-load-panel>
